import { render, staticRenderFns } from "./VideoWallWidget.vue?vue&type=template&id=3fae5dcc&scoped=true"
import script from "./VideoWallWidget.vue?vue&type=script&lang=js"
export * from "./VideoWallWidget.vue?vue&type=script&lang=js"
import style0 from "./VideoWallWidget.vue?vue&type=style&index=0&id=3fae5dcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fae5dcc",
  null
  
)

export default component.exports